import {
  AfterViewInit,
  Component,
  ElementRef,
  OnInit,
  Renderer2,
} from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';

import { MainComponent } from 'src/app/modals/login/main/main.component';
import { AuthService } from 'src/app/services/auth.service';
import { DhprofileService } from 'src/app/services/dhprofile.service';
import { LangService } from 'src/app/services/lang.service';

@Component({
  selector: 'app-level2',
  templateUrl: './level2.component.html',
  styleUrls: ['./level2.component.scss'],
})
export class Level2Component implements OnInit, AfterViewInit {
  public currentLang: string | null = 'en';

  constructor(
    private router: Router,
    private dhProfileService: DhprofileService,
    private elementRef: ElementRef,
    private renderer: Renderer2,
    private auth: AuthService,
    private modalService: NgbModal,
    private lang: LangService,
    private route: ActivatedRoute
  ) {
    this.lang.language.subscribe((lang) => {
      this.currentLang = lang || 'en';
    });

    this.route.url.subscribe(() => {
      if (this.router.url === '/doublehealixprofile/level-2') {
        this.lang.setLanguage('en');
        this.currentLang = 'en';
      }
      if (this.router.url === '/doublehealixprofiel/level-2') {
        this.lang.setLanguage('nl');
        this.currentLang = 'nl';
      }
    });
  }

  checkCurrentRoute() {
    if (this.router.url === '/dh/level-2') {
      let language: any = '';
      language = localStorage.getItem('language') || this.currentLang;
      if (language == 'nl') {
        this.router.navigate(['/doublehealixprofiel/level-2']);
        this.lang.setLanguage('nl');
      } else {
        this.router.navigate(['/doublehealixprofile/level-2']);
        this.lang.setLanguage('en');
      }
    }
  }

  ngAfterViewInit(): void {
    this.checkCurrentRoute();
  }

  ngOnInit(): void {}

  goBack() {
    if (this.currentLang == 'nl') {
      this.router.navigate(['/doublehealixprofiel']);
    } else {
      this.router.navigate(['/doublehealixprofile']);
    }
  }

  async getFormLevel2() {
    if (!this.auth.isAuthenticated()) {
      this.login();
      return;
    }
    const data = {
      type: 'quest_level_2',
      user_id: 2222,
    };
    await this.dhProfileService
      .createQuestionnaire(data)
      .then((resp) => {
        this.router.navigate(['/dh', 'questionnaire', resp.id]);
      })
      .catch((error) => {
        console.log(error);
      });
  }

  login(): void {
    const modalRef = this.modalService.open(MainComponent, {
      windowClass: 'login-modal',
    });
    modalRef.componentInstance.state = 'register';
    modalRef.componentInstance.selfModal = modalRef;
    modalRef.componentInstance.showMessage = true;
  }
}
